export const MONTH_OPTIONS = [
  { key: '2026-09', label: 'September 2026', year: 2026, monthIndex: 8 },
  { key: '2026-10', label: 'October 2026', year: 2026, monthIndex: 9 },
  { key: '2026-11', label: 'November 2026', year: 2026, monthIndex: 10 },
  { key: '2026-12', label: 'December 2026', year: 2026, monthIndex: 11 },
];

// Event image convention:
// - Store official assets in /public/static/events/
// - Keep one file per event using stable, event-specific filenames
// - Missing files fall back to /static/events/event-image-placeholder.svg in EventsPage

export const EVENTS_DATA = [
  {
    id: 'love-among-the-pages-2026',
    name: 'Love Among the Pages',
    startDate: '2026-09-18',
    endDate: '2026-09-20',
    dateTba: false,
    city: 'London',
    province: 'ON',
    venue: 'RBC Place London',
    eventType: 'Romance Book Convention',
    description:
      'An inclusive romance book convention bringing together readers, authors and industry professionals across romance subgenres and spice levels.',
    admission: 'Ticketed',
    image: '/static/events/love-among-the-pages.png',
    imageAlt: 'Love Among the Pages 2026 event promotional artwork',
    websiteUrl: 'https://haustierevents.com/',
    featured: true,
  },
  {
    id: 'word-on-the-street-toronto-2026',
    name: 'The Word On The Street Toronto',
    startDate: '2026-09-26',
    endDate: '2026-09-27',
    dateTba: false,
    city: 'Toronto',
    province: 'ON',
    venue: 'David Pecaut Square',
    eventType: 'Literary Festival',
    description:
      'A major outdoor literary festival bringing together authors, publishers, independent presses and a huge books-and-magazines marketplace in downtown Toronto.',
    admission: 'Free',
    image: '/static/events/wots-logo.png',
    imageAlt: 'The Word On The Street Toronto 2026 logo',
    websiteUrl: 'https://toronto.thewordonthestreet.ca/event-directory/annual-festival/2026-festival/',
    featured: true,
  },
  {
    id: 'stories-from-the-stars-2026',
    name: 'Stories from the Stars: A Sci-Fi Book Fair',
    startDate: '2026-09-26',
    endDate: '2026-09-26',
    dateTba: false,
    city: 'Dartmouth',
    province: 'NS',
    venue: 'Hal-Con Event Area, Dartmouth',
    eventType: 'Sci-Fi Book Fair',
    description:
      'A sci-fi-focused book fair featuring authors, booksellers and book-adjacent vendors for readers and fans of speculative fiction.',
    admission: 'Free',
    image: '/static/events/stories-from-the-stars.jpg',
    imageAlt: 'Stories from the Stars 2026 promotional artwork',
    websiteUrl: 'https://hal-con.com/schedule-and-events/year-round-events/stories-from-the-stars',
  },
  {
    id: 'romance-eh-2026',
    name: 'Romance Eh',
    startDate: '2026-10-02',
    endDate: '2026-10-03',
    dateTba: false,
    city: 'Enoch',
    province: 'AB',
    venue: 'River Cree Resort & Casino',
    eventType: 'Romance Book Signing & Reader Event',
    description:
      'A Canadian romance reader and author event featuring a Friday mixer followed by author signing sessions and bookish shopping on Saturday.',
    admission: 'Ticketed',
    image: '/static/events/romance-eh.jpeg',
    imageAlt: 'Romance Eh 2026 promotional artwork',
    websiteUrl: 'https://www.romanceeh.com/',
  },
  {
    id: 'wordstock-sudbury-2026',
    name: 'Wordstock Sudbury Literary Festival',
    startDate: '2026-10-16',
    endDate: '2026-10-17',
    dateTba: false,
    city: 'Sudbury',
    province: 'ON',
    venue: 'Place des Arts du Grand Sudbury',
    eventType: 'Literary Festival',
    description:
      'Two days of Canadian writers, readings, workshops, community events and conversations celebrating the literary arts in Northern Ontario.',
    admission: 'Ticketed',
    image: '/static/events/Wordstock-Header-Logo.svg',
    imageAlt: 'Wordstock Sudbury 2026 promotional artwork',
    websiteUrl: 'https://wordstocksudbury.ca/event/wordstock-sudbury-literary-festival-2026',
  },
  {
    id: 'royal-city-romance-2026',
    name: 'Royal City Romance Book Event',
    startDate: '2026-10-31',
    endDate: '2026-10-31',
    dateTba: false,
    city: 'Guelph',
    province: 'ON',
    venue: 'Delta Hotels Guelph Conference Centre',
    eventType: 'Romance Book Event',
    description:
      'A romance-focused day of authors, bookish vendors, shopping and signings in Guelph.',
    admission: 'Ticketed',
    image: '/static/events/royal-city.avif',
    imageAlt: 'Royal City Romance 2026 promotional artwork',
    websiteUrl: 'https://www.royalcityromance.ca/',
  },
  {
    id: 'ink-of-the-aurora-2026',
    name: 'Ink of the Aurora',
    startDate: '2026-11-13',
    endDate: '2026-11-14',
    dateTba: false,
    city: 'Winnipeg',
    province: 'MB',
    venue: 'Winnipeg Event Venue',
    eventType: 'Book Signing & Reader Event',
    description:
      'A Winnipeg bookish event bringing authors and readers together for signings, books and reader-focused programming.',
    admission: 'Ticketed',
    image: '/static/events/ink-of-the-aurora.jpeg',
    imageAlt: 'Ink of the Aurora 2026 promotional artwork',
    websiteUrl: 'https://www.instagram.com/inkoftheaurora/',
  },
  {
    id: 'pages-and-pleasures-ancaster-2026',
    name: 'Pages & Pleasures - Ancaster',
    startDate: '2026-11-14',
    endDate: '2026-11-14',
    dateTba: false,
    city: 'Ancaster / Jerseyville',
    province: 'ON',
    venue: 'Ancaster Fairgrounds / Marrit Hall, 630 Trinity Rd S',
    eventType: 'Romance Book Fair & Market',
    description:
      'A romance book fair and market featuring 70+ authors, publishers, makers and vendors, with free general admission and VIP early access.',
    admission: 'Free general admission, 11:00 AM-4:00 PM',
    image: '/static/events/pages-pleasures.jpeg',
    imageAlt: 'Pages and Pleasures Ancaster 2026 promotional artwork',
    websiteUrl: 'https://www.pagesandpleasures.com/event-details/ancaster-pages-pleasures-november-14-2026',
  },
  {
    id: 'frostbitten-and-forbidden-2026',
    name: 'Frostbitten & Forbidden - A Winter Fantasy Ball',
    startDate: '2026-12-04',
    endDate: '2026-12-04',
    dateTba: false,
    city: 'Hamilton',
    province: 'ON',
    venue: 'Hamilton Convention Centre',
    eventType: 'Fantasy Ball / Bookish Event',
    organizer: 'Pages & Pleasures',
    description:
      'A winter fantasy ball hosted by Pages & Pleasures, bringing readers together for an immersive evening of fantasy-inspired celebration in Hamilton.',
    admission: 'Ticketed',
    image: '/static/events/frostbitten-forbidden.webp',
    imageAlt: 'Frostbitten & Forbidden 2026 promotional artwork',
    websiteUrl:
      'https://www.pagesandpleasures.com/event-details/frostbitten-forbidden-a-winter-fantasy-ball-hamilton',
  },
  {
    id: 'pages-and-pleasures-hamilton-2026',
    name: 'Pages & Pleasures - Hamilton Romance Book Fair & Market',
    startDate: '2026-12-05',
    endDate: '2026-12-05',
    dateTba: false,
    city: 'Hamilton',
    province: 'ON',
    venue: 'Hamilton Convention Centre',
    eventType: 'Romance Book Fair & Market',
    organizer: 'Pages & Pleasures',
    description:
      'A romance-focused book fair and market featuring authors, bookish vendors and reader-friendly shopping in downtown Hamilton.',
    admission: 'Free general admission, 11:00 AM-4:00 PM',
    image: '/static/events/pages-pleasures.jpeg',
    imageAlt: 'Pages and Pleasures Hamilton 2026 promotional artwork',
    websiteUrl:
      'https://www.pagesandpleasures.com/event-details/hamilton-romance-book-fair-and-market-saturday-december-5',
  },
  {
    id: 'read-quebec-book-fair-2026',
    name: 'Read Quebec Book Fair',
    startDate: '',
    endDate: '',
    dateTba: true,
    city: 'Montreal',
    province: 'QC',
    venue: 'Montreal venue to be announced',
    eventType: 'Book Fair',
    description:
      'A celebration of English-language Quebec books and writers, bringing readers, authors and publishers together in Montreal.',
    admission: 'TBA',
    image: '/static/events/read-quebec-book-fair-2026.jpg',
    imageAlt: 'Read Quebec Book Fair 2026 event poster',
    websiteUrl: 'https://qwf.org/activities/series-events/read-quebec-book-fair/',
  },
];
